import * as firebase from "firebase"
require("firebase/firestore")

export const getDocumentsFromCollection = (collection, references) => {
  let collectionRef = firebase.firestore().collection(collection)
  let results = []

  return (
    collectionRef
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(async doc => {
          let data = doc.data()

          if (references) {
            for (let reference of references) {
              if (data[reference]) {
                if (Array.isArray(data[reference])) {
                  let refs_data = []
                  for (let ref of data[reference]) {
                    await ref.get().then(reference_result => {
                      let reference_data = reference_result.data()
                      reference_data.id = reference_result.id
                      refs_data.push(reference_data)
                    })
                  }
                  data[reference] = refs_data
                } else {
                  await data[reference].get().then(reference_result => {
                    let reference_data = reference_result.data()
                    reference_data.id = reference_result.id
                    data[reference] = reference_data
                  })
                }
              }
            }
          }

          results.push({
            id: doc.id,
            ...data
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const getHomeSettings = () => {
  let reference = firebase.firestore().collection('settings').doc('home')

  return (
    reference
    .get()
    .then(snapshot => {
      return snapshot.data()
    })
    .catch(error => {
      throw error
    })
  )
}

export const saveHomeSetting = settings => {
  let reference = firebase.firestore().collection('settings').doc('home')

  return reference
    .set(settings)
    .then(() => {
      return true
    })
    .catch(error => {
      throw error
    })
}
